module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/header-small.23dc73b5c450fe6f.png";